import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AI_VIDEO_REVIEW } from '../../../shared/constants/api-routes';

export interface AiVideoReviewCountsDto {
  readonly flaggedVideosAmount: number;
  readonly unflaggedVideosAmount: number;
}

export interface AiVideoReviewCountsRequestDto {
  readonly CutoffDate: string;
}

function toLocalDateTimeNoTz(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

@Injectable({ providedIn: 'root' })
export class AiVideoReviewService {
  private readonly http = inject(HttpClient);

  getCounts(cutoffDate: Date): Observable<AiVideoReviewCountsDto> {
    const url = `${environment.matrixApiUrl}/${AI_VIDEO_REVIEW.AI_VIDEO_REVIEW_COUNTS()}`;
    const body: AiVideoReviewCountsRequestDto = { CutoffDate: toLocalDateTimeNoTz(cutoffDate) };
    return this.http.post<AiVideoReviewCountsDto>(url, body);
  }
}

